import { createContext, useContext, useState, useCallback, useRef } from 'react';
import ConfirmDialog from './ConfirmDialog';

const ConfirmContext = createContext(() => Promise.resolve(false));

// Imperative confirm(): const confirm = useConfirm(); if (await confirm({title,message})) {...}
export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, options: {} });
  const resolver = useRef(null);

  const confirm = useCallback((options = {}) => {
    // Settle any still-pending confirmation so a rapid second call can't orphan the first promise.
    resolver.current?.(false);
    setState({ open: true, options });
    return new Promise((resolve) => {
      resolver.current = resolve;
    });
  }, []);

  const close = useCallback((result) => {
    setState((s) => ({ ...s, open: false }));
    resolver.current?.(result);
    resolver.current = null;
  }, []);

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <ConfirmDialog
        open={state.open}
        {...state.options}
        onConfirm={() => close(true)}
        onClose={() => close(false)}
      />
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmContext);
export default ConfirmProvider;
